var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('vbt-badge',{attrs:{"color":_vm.color,"small":""}},[_vm._t("default")],2):_c('span',[_vm._v(" - ")])}
var staticRenderFns = []

export { render, staticRenderFns }